export enum ApplicationAreaScreen {
  'FILE' = 'FILE',
  'INFORMATION_FORM' = 'INFORMATION_FORM',
}
